/* lua.js generated code 0.3.0 */
var AdStartRewardPanel = xClass("AdStartRewardPanel", BasePanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/level_difficulty_reward_video.csb")
})
AdStartRewardPanel.prototype.ctor = function (adStartReward, callback) {
    var self = this;
    console.log("adstart adreward", adStartReward)
    BasePanel.prototype.ctor.call(self)
    self.adStartReward = adStartReward
    self.isopen = true

    for (var i = 1; i < self.adStartReward.length; i++){
        // console.log("adstart self.adStartReward[i]", self.adStartReward[i])
        var ph = self.getChildByName("reward_bubble_big"+ tostring(i))
        var sprite = UIItemBuilder.createPropIcon(self.adStartReward[i])
        var size = ph.getContentSize()
        var scale = ph.getScaleX()
        sprite.setScale(size.width * scale / sprite.getContentSize().width)
        sprite.setPosition(cc.p(size.width * scale / 2, size.height * ph.getScaleY() / 2))
        ph.setSpriteFrame(sprite.getSpriteFrame())
    }

    let ani = cc.CSLoader.createTimeline("cocos/level_difficulty_reward_video.csb")
    self.runAction(ani)
    ani.gotoFrameAndPlay(0, 70, false);
    // ani.play("appear", false);
    ani.setLastFrameCallFunc(function(){
        console.log("adstart calllastframe")

        if (!self.isopen){
            return
        }
        self.isopen = false

        if (callback){
            callback()
        }
      
        self.onClose()

    });
    SpriteUtil.findBlendChilds_AddOneOne(self, false)

    //点击层
    var visibleSize = cc.Director.getInstance().getVisibleSize()
    var container = cc.LayerColor.create(new cc.Color(255, 0, 0, 0), visibleSize.width, visibleSize.height);
    container.setPosition(-visibleSize.width / 2.0, -visibleSize.height / 2.0)
    self.addChild(container)
    UIButton.create(container, true).on(UIButtonEvent.Click, function () {
        console.log("adstart click")
        if (!self.isopen){
            return
        }
        self.isopen = false
        if (callback){
            callback()
        }
      
        self.onClose()

    })

    self.popup();
}

module.exports = AdStartRewardPanel;
